<template>
  <transition name="cube-picker-fade">
    <cube-popup
      v-show="isVisible"
      ref="myPopup"
      type="select-tree-pop"
      :center="false"
      :mask-closable="maskClosable || true"
      position="bottom"
      @mask-click="maskClick"
    >
      <transition name="cube-picker-move">
        <div
          v-show="isVisible"
          class="cube-picker-panel cube-safe-area-pb"
          @click.stop
        >
          <!-- <div class="cube-picker-choose border-bottom-1px">
            <span
              class="cube-picker-cancel"
              @click="cancel"
            >{{ _cancelTxt }}</span>
            <span
              class="cube-picker-confirm"
              @click="confirm"
            >{{ _confirmTxt }}</span>
            <div class="cube-picker-title-group">
              <h1
                class="cube-picker-title"
                v-html="title"
              />
              <h2
                v-if="subtitle"
                class="cube-picker-subtitle"
                v-html="subtitle"
              />
            </div>
          </div> -->
          <div
            ref="wrapper"
            class="cube-picker-content"
          >
            <cube-scroll ref="scroll">
              <div class="wrapper">
                <class-child
                  v-if="data && data.length"
                  :child="data"
                  @change="handleChange"
                />
              </div>
            </cube-scroll>
          </div>

          <cube-form-group class="cube-picker-footer footer form-btn-box">
            <cube-button
              class="cancel-btn cube-btn-light"
              @click="handleCancel"
            >
              {{ cancelText }}
            </cube-button>
            <cube-button
              class="confirm-btn cube-btn-primary"
              @click="handleConfirm"
            >
              {{ confirmText }}
            </cube-button>
          </cube-form-group>
        </div>
      </transition>
    </cube-popup>
  </transition>
</template>

<script>
import ClassChild from './ClassChild'
import { cloneDeep } from 'lodash'
import i18n from '@/lib/language'

const COMPONENT_NAME = 'cube-select-tree'
const EVENT_CANCEL = 'cancel'
const EVENT_CONFIRM = 'confirm'

export default {
  name: COMPONENT_NAME,
  components: {
    ClassChild
  },
  props: {
    options: {
      type: [Object, Array],
      default: () => { }
    },
    defaultValue: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    cancelTxt: {
      type: String,
      default: ''
    },
    confirmTxt: {
      type: String,
      default: ''
    },
    onlychooselast: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isVisible: false,
      data: this.options,
      selectList: [],
      result: [],
      copySelectList: []
    }
  },
  computed: {
    _cancelTxt () {
      return this.cancelTxt || i18n.t('message["896"]')
    },
    _confirmTxt () {
      return this.confirmTxt || i18n.t('message["915"]')
    },
    cancelText () {
      return i18n.t('message["896"]')
    },
    confirmText () {
      return i18n.t('message["915"]')
    }
  },
  watch: {
    isVisible: {
      handler (val) {
        // 每次弹窗打开时，更新默认值
        if (val && this.data.length) {
          this.formateData(this.data)
          this.setDefault()
          setTimeout(() => {
            this.$refs.scroll.forceUpdate()
            this.$refs.scroll.refresh()
          }, 1000)
        }
      },
      immediate: true
    }
  },

  created () {
    // 详情页有数据时，展示默认值
    this.formateData(this.data)
    this.setDefault()
  },

  methods: {
    formateData (child) {
      for (let i in child) {
        let item = child[i]
        item.name = item.name || item.fieldname
        item.child = item.child || item.children || item.options
        this.$set(item, 'show', true)
        this.$set(item, 'checked', false)
        if (item.child && item.child.length) {
          this.formateData(item.child)
          if (this.onlychooselast) {
            item.disabled = true
          }
        } else {
          if (this.onlychooselast) {
            item.disabled = false
          }
        }
      }
    },
    handleChange (item) {
      this.selectList = this.selectList || []
      if (item.checked) {
        if (!this.result.includes(item.id)) {
          this.result.push(item.id)
          this.selectList.push(item)
        }
      } else {
        if (this.result.includes(item.id)) {
          let index = this.result.findIndex(one => item.id === one)
          this.result.splice(index, 1)
          this.selectList.splice(index, 1)
        }
      }
    },
    setDefault (val) {
      let ids = this.defaultValue
      this.result = ids
      this.selectList = this.setTreeValue(ids)
      if (!this.copySelectList.length) {
        this.copySelectList = cloneDeep(this.selectList)
      }
      // 有选择值时，将包含name的list数据返回给父级
      this.$emit('getDefault', this.copySelectList)
    },
    setTreeValue (ids = []) {
      let res = []
      if (!ids || !ids.length) return res

      for (let id of ids) {
        this.setChild(res, id, this.data)
      }
      return res
    },
    setChild (res, id, data) {
      for (let i in data) {
        let item = data[i]
        if (parseInt(id) === item.id) {
          this.$set(item, 'checked', true)
          res.push(item)
          this.$forceUpdate()
        }
        item.child = item.child || item.children || item.options
        if (item.child) {
          this.setChild(res, id, item.child)
        }
      }
    },
    show () {
      this.isVisible = true
    },
    hide () {
      this.isVisible = false
    },
    maskClick () {
      this.maskClosable && this.cancel()
    },
    handleCancel () {
      this.result = this.copySelectList.map(item => item.id)
      this.hide()
      this.$emit(EVENT_CANCEL, this.result, this.copySelectList)
    },
    handleConfirm () {
      this.hide()
      this.copySelectList = cloneDeep(this.selectList)
      this.$emit(EVENT_CONFIRM, this.result, this.selectList)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cube-popup-content {
  height: 100%;
}
.cube-picker-panel {
  width: 100%;
  height: 100%;
  text-align: left;
}
.cube-picker-content {
  top: 0;
  height: 100%;
  padding-bottom: 70px;
  overflow: hidden;
}
.wrapper {
  width: 100%;
  height: 100%;
}
.cube-btn {
  width: 48%;
}
</style>
